var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTwoWayArrows = function SvgTwoWayArrows(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    fill: "none",
    viewBox: "0 0 13 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M8.652 8c-.234 0-.502-.084-.703-.252-.4-.307-.4-.839 0-1.175l2.074-1.734H.84C.376 4.84 0 4.463 0 4c0-.463.376-.84.84-.84h9.183L7.95 1.428c-.4-.308-.4-.84 0-1.175.368-.336 1.004-.336 1.405 0l3.044 2.545c.401.308.602.755.602 1.203 0 .448-.2.867-.602 1.203L9.354 7.748c-.2.168-.468.252-.702.252zM4.348 7c.234 0 .502.084.703.252.4.307.4.839 0 1.175L2.977 10.16h9.184c.463 0 .839.376.839.839 0 .463-.376.84-.84.84H2.978l2.074 1.733c.4.308.4.84 0 1.175-.368.336-1.004.336-1.405 0L.602 12.203C.201 11.895 0 11.448 0 11c0-.448.2-.867.602-1.203l3.044-2.545c.2-.168.468-.252.702-.252z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTwoWayArrows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/two-way-arrows.2c311f0d587929a04a20704b8fb4e1d4.svg";